import { render, staticRenderFns } from "./BuzonSunatView.vue?vue&type=template&id=55ae4ce0&scoped=true"
import script from "./BuzonSunatView.vue?vue&type=script&lang=js"
export * from "./BuzonSunatView.vue?vue&type=script&lang=js"
import style0 from "./BuzonSunatView.vue?vue&type=style&index=0&id=55ae4ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ae4ce0",
  null
  
)

export default component.exports